module.exports = __webpack_public_path__ + "img/oiseau_qui_chante.910756ce.webp";